import { signal } from "@preact/signals-react";

export const enviarImagens = signal(null);
export const anexos = signal([]);
export const anexoExterno = signal(null);